import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortlistFlightPlan',
    standalone: false
})
export class SortlistFlightPlanPipe implements PipeTransform {

  public transform(arr: any) {
    if (!Array.isArray(arr)) {
      return arr;
    }
    // Return a sorted copy so Angular/Swiper item state is not reset by in-place mutation.
    return [...arr].sort((a, b) => {
      const aOrder = a?.CBPAttachmentDetails?.Selected == '1' ? -1 : 1;
      const bOrder = b?.CBPAttachmentDetails?.Selected == '1' ? -1 : 1;
      return aOrder - bOrder;
    });
  }
}
